import { toast } from "@shuttlerock/mui-components";
import { useTranslation } from "../i18n";

export type UseClipboardOptions = {
  successMessage?: string;
  errorMessage?: string;
};

export type UseClipboard = {
  /** Resolves whether the value reached the clipboard; a failure is toasted, never thrown. */
  copyToClipboard: (value: string, options?: UseClipboardOptions) => Promise<boolean>;
};

export const useClipboard = (): UseClipboard => {
  const { t } = useTranslation();

  const copyToClipboard = async (
    value: string,
    {
      successMessage = t("useClipboard:copySuccess"),
      errorMessage = t("useClipboard:copyError"),
    }: UseClipboardOptions = {},
  ) => {
    try {
      // Without a clipboard (an insecure context) nothing was copied, so this fails too.
      await navigator.clipboard.writeText(value || "");
      toast.success(successMessage);
      return true;
    } catch {
      toast.error(errorMessage);
      return false;
    }
  };

  return {
    copyToClipboard,
  };
};
